'use client';

import { Stack } from '@react/chakra';
import { Quote } from '@react/chakra/core';
import { useSuspenseQuery } from '@react/utils/queryHooks';

import type { JSX } from 'react';

import { quotesOptions } from '../queries';

export function QuoteList(): JSX.Element {
  const { data } = useSuspenseQuery(quotesOptions());

  return (
    <Stack gap={40} w='100%' alignItems='center' justifyContent='center'>
      {data.map((datumn) => {
        return <Quote key={datumn.content} data={datumn} />;
      })}
    </Stack>
  );
}
